( function( factory ) {
	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [ "jquery", "./version" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} ( function( $ ) {

// This file is deprecated
return $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
} ) );



//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/jquery-ui/ui/ie.js
// module id = 405
// module chunks = 0